<div style="padding: 10px" [innerHTML]="message | keepHtml">
</div>
<p-footer>
    <button *ngFor="let button of buttons" class="mr-1" type="button" pButton [icon]="button.icon" [label]="button.caption" (click)="click(button.id)" style="margin-right: 5px; margin-top: 10px"></button>
</p-footer>
